import { useContext } from 'react';
import { globalAction } from '../../store';
import { Alert } from '@mui/material';

export const GlobalAlert = () => {
  const { state } = useContext(globalAction);
  const { notify } = state || {};
  const { isOpen: isNotificationOpen, message, type } = notify || {};

  return (
    <Alert
      severity={type}
      sx={{
        right: '1rem',
        minWidth: '20rem',
        position: 'absolute',
        paddingBlock: 2,
        opacity: isNotificationOpen ? 1 : 0,
        bottom: isNotificationOpen ? '2rem' : '-10rem',
        transition: '500ms ease-in-out',
      }}
    >
      {message}
    </Alert>
  );
};
